import { contracts } from '@/constants/contracts.constant';

export const allowance = (state, getters, rootState) => (tokenAddress) => {
  const connectedChainId = rootState?.wallet?.provider.chainId;
  const account = rootState?.wallet?.provider?.address;
  const spender = contracts.projectManagement[connectedChainId];
  return state.data[`${connectedChainId}${account}${tokenAddress}${spender}`] || 0;
};
